export default __webpack_public_path__ + "static/media/EN_15.563a4ca8.svg";